<!--
 * @Author: your name
 * @Date: 2021-03-25 16:10:36
 * @LastEditTime: 2021-03-31 10:16:42
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /zmbiz-mobile-work-front/src/pages/interviewnew/components/resumeUrl.vue
-->
<template>
  <div>
    <van-popup
      v-model="drawer"
      get-container="body"
      position="bottom"
      round
      :style="{ height: '85%' }"
      closeable
    >
      <img
        :src="resumeUrl"
        alt=""
        @click="previewImage"
        v-if="isImg"
        width="100%"
      />
      <div class="drawer-content" v-else></div>
    </van-popup>
    <van-popup
      v-model="iosDownloadPop"
      get-container="body"
      position="bottom"
      round
      :style="{ height: '85%' }"
      closeable
    >
      <div class="ios-download">
        <p>暂不支持此文件格式预览</p>
        <p>点复制地址按钮, 到 <span>safari</span> 中打开并下载。</p>
        <input
          id="copy-txt"
          type="text"
          v-model="resumeUrl"
          style="color: #fff; border: none"
        />
        <div class="downloadBtn" @click="copyTXT">复制地址</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Vue from 'vue';
import { Toast } from 'vant';
import Pdfh5 from 'pdfh5';
import 'pdfh5/css/pdfh5.css';
import * as dd from 'dingtalk-jsapi';

Vue.use(Toast);

export default {
  data() {
    return {
      resumeUrl: '',
      drawer: false,
      iosDownloadPop: false,
      isImg: false,
    };
  },
  methods: {
    init(item) {
      if (!item.resumeUrl) return Toast('无更多简历信息');
      this.resumeUrl = item.resumeUrl;
      this.viewResume(this.resumeUrl);
    },

    getFileType(url) {
      return url.substring(url.lastIndexOf('.'), url.length).toLowerCase();
    },

    isDownloadFile(url) {
      const fileTypes = ['.pdf', '.png', '.jpg', '.jpeg', '.bpm', '.gif'];
      return !fileTypes.includes(this.getFileType(url));
    },

    viewResume(url) {
      this.isImg = false;
      this.resumeUrl = '';
      const fileType = this.getFileType(url);
      // 苹果手机提示
      if (this.isDownloadFile(url)) {
        if (this.isIOS()) {
          this.resumeUrl = url;
          this.iosDownloadPop = true;
        } else {
          Toast.fail('简历将下载至本地，请在本地查看');
          const elemIF = document.createElement('iframe');
          elemIF.src = url;
          elemIF.style.display = 'none';
          document.body.appendChild(elemIF);
          setTimeout(() => {
            document.body.removeChild(elemIF);
          }, 1000);
        }
        return false;
      }

      // 在线预览
      this.drawer = true;
      if (fileType === '.pdf') {
        this.$nextTick(() => {
          const pd = new Pdfh5(document.querySelector('.drawer-content'), {
            pdfurl: url,
          });
          pd.on('complete', (status, msg, time) => {
            if (status !== 'success') {
              this.status = true;
              Toast.fail('预览失败 请稍后再试');
            }
          });
        });
      } else {
        this.isImg = true;
        this.resumeUrl = url;
      }
    },

    isIOS() {
      return /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent);
    },

    copyTXT() {
      try {
        const range = document.createRange();
        range.selectNode(document.querySelector('#copy-txt'));
        const selection = window.getSelection();
        if (selection.rangeCount > 0) selection.removeAllRanges();
        selection.addRange(range);
        document.execCommand('copy');
        Toast('复制成功');
      } catch (err) {
        Toast('复制失败');
      }
      window.getSelection().removeAllRanges(); // 移除选中的元素
    },

    previewImage() {
      if (dd.env.platform === 'notInDingTalk') return;
      dd.biz.util.previewImage({
        urls: [this.resumeUrl],
        current: this.resumeUrl,
      });
    },
  },
};
</script>
<style lang="scss">
.drawer-content {
  height: 100vh;
}
.downloadBtn {
  color: #f1524a;
  border: 2px solid #f1524a;
  display: inline-block;
  width: 100%;
  height: 66px;
  line-height: 66px;
  text-align: center;
  border-radius: 36px;
}
.ios-download {
  padding: 20px 40px;
  word-break: break-all;
  font-size: 32px;
  margin-top: 100px;
  text-align: center;
  line-height: 56px;
  span {
    color: red;
    font-weight: 800;
  }
}
</style>